module.exports = __webpack_public_path__ + "static/media/paulo-pinto.d08d97f5.png";